import PageBreadcrumb from '../../../components/common/PageBreadCrumb';
import SubscriptionsTable from '../../../components/payments/subscriptions/table';
import PageMeta from '../../../components/common/PageMeta';

const Subscriptions = () => {
  return (
    <div>
      <PageMeta title="Subscriptions" description="List of Subscriptions" />
      <PageBreadcrumb pageTitle="Subscriptions" />
      <SubscriptionsTable />
    </div>
  );
};

export default Subscriptions;
